'use strict';

module.exports = require('../functions/makeLang')({
	month: 'month',
	year: 'year'
});
